<template>
	<v-card class="mb-1">
		<v-card-title>
			<div v-html="question.question_pt"/>
			<v-spacer></v-spacer>
			<v-btn class="ml-3" icon @click="showEdit = true">
				<v-icon color="primary">mdi-pencil</v-icon>
			</v-btn>
			<v-btn class="ml-1" icon @click="showDeleteQuestion = true">
				<v-icon color="primary">mdi-delete</v-icon>
				<DeleteConfirmationDialog v-model="showDeleteQuestion" item="alert" @delete="deleteQuestion" />
			</v-btn>
		</v-card-title>
		<v-card-text>
			<div v-html="question.answer_pt"/>
      <v-chip>{{topic}}</v-chip>
		</v-card-text>
		<v-dialog v-model="showEdit" max-width="70%" scrollable>
			<v-card>
				<v-card-title class="title primary--text mb-2 secondary">
					<translate>Edit</translate>
				</v-card-title>
				<v-card-text class="pt-2">
					<v-form ref="questionForm" v-model="validForm">
						<v-row no-gutters>
              <v-col cols="12">
								Pergunta PT
								<RichTextEditor key="pt-title" ref="questionPT" :text="question.question_pt" />
							</v-col>
              <v-col cols="12">
								Pergunta EN
								<RichTextEditor key="en-title" ref="questionEN" :text="question.question_en" />
							</v-col>
              <v-col cols="12">
								Pergunta ES
								<RichTextEditor key="es-title" ref="questionES" :text="question.question_es" />
							</v-col>
							<v-col cols="12" class="mt-10">
								Resposta PT
								<RichTextEditor key="pt-text" ref="answerPT" :text="question.answer_pt" />
							</v-col>
							<v-col cols="12">
								Resposta EN
								<RichTextEditor key="en-text" ref="answerEN" :text="question.answer_en" />
							</v-col>
							<v-col cols="12">
								Resposta ES
								<RichTextEditor key="es-text" ref="answerES" :text="question.answer_es" />
							</v-col>
              <v-col cols="12" md="4" class="mt-10">
								<v-select
									v-model="question.topic_id"
									:items="topics"
									:label="$gettext('Topic')"
									item-text="name_pt"
									item-value="id"
									outlined
									:rules="[required]"
                  no-data-text="Não existem tópicos criados."
								></v-select>
							</v-col>
							<v-col cols="6" class="mt-10">
								<v-img
									v-if="question.image_url"
									:src="question.image_url"
									contain
								/>
								<v-file-input
									accept="image/png, image/jpeg, image/bmp"
									label="Imagem"
									v-model="imageUpload"
									outlined
									class="px-2"
									hide-details
								></v-file-input>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-btn color="primary darken-1" text @click="showEdit = false">
						<translate key="close">Close</translate>
					</v-btn>
					<v-spacer></v-spacer>
					<v-btn color="primary darken-1" text @click="editQuestion">
						<translate key="save">Save</translate>
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-card>
</template>

<script>
import DeleteConfirmationDialog from "@/components/DeleteConfirmationDialog.vue";
import axios from "axios";
import RichTextEditor from "@/components/RichTextEditor.vue";

export default {
  name: "QuestionAnswer",
  props: ["question", "topics"],
  components: {
		DeleteConfirmationDialog,
		RichTextEditor
  },
  data: () => ({
    showEdit: false,
		validForm: false,
		showDeleteQuestion: false,
		imageUpload: null
  }),
  computed: {
		required() {
			return value => !!value || this.$gettext("Required.");
    },
    topic() {
      for(let i = 0; i < this.topics.length; i++) {
        if(this.topics[i].id == this.question.topic_id) return this.topics[i].name_pt;
      }
      return "";
    }
  },
  methods: {
    editQuestion() {
      if (this.$refs.questionForm.validate()) {
        const form = new FormData();
        form.append("question_pt", this.$refs.questionPT.getHTML());
        form.append("question_en", this.$refs.questionEN.getHTML());
        form.append("question_es", this.$refs.questionES.getHTML());
				form.append("answer_pt", this.$refs.answerPT.getHTML());
				form.append("answer_en", this.$refs.answerEN.getHTML());
        form.append("answer_es", this.$refs.answerES.getHTML());
        form.append("topic_id", this.question.topic_id);
				if(this.imageUpload) form.append("image_upload", this.imageUpload);
				axios
					.post("/admin/question-answers/" + this.question.id + "/edit", form)
					.then(response => {
						console.log(response.data);
						if (response.data.result == "ok") {
              this.$emit("edit-question", response.data.question);
							this.showEdit = false;
							this.imageUpload = null;
						}
					})
					.catch(error => console.log(error));
			}
    },
    deleteQuestion() {
      axios
				.post("/admin/question-answers/" + this.question.id + "/delete")
				.then(response => {
					console.log(response.data);
					if (response.data.result == "deleted") {
            this.$emit("delete-question", this.question);
            this.showDeleteQuestion = false;
          }
					else this.showError = true;
				})
				.catch(error => console.log(error));
    }
  }
}
</script>